import posthog from "posthog-js";
import { closeSentry, initSentry } from "@/utils/initSentry";

type CookieConsent = "all" | "deny";

const COOKIE_CONSENT_KEY = "cookie-consent";
const COOKIE_CONSENT_CHANGED_EVENT = "cookie-consent-changed";

const LEGACY_VALUES: Record<string, CookieConsent> = {
  essential: "deny",
  reject: "deny"
};

const getCookieConsentState = (): CookieConsent | undefined => {
  const raw = localStorage.getItem(COOKIE_CONSENT_KEY) ?? undefined;
  if (raw === undefined) {
    return undefined;
  }

  const migrated = LEGACY_VALUES[raw];
  if (migrated) {
    localStorage.setItem(COOKIE_CONSENT_KEY, migrated);
    return migrated;
  }

  if (raw === "all" || raw === "deny") {
    return raw;
  }
  return undefined;
};

const setCookieConsentState = (consent: CookieConsent): void => {
  localStorage.setItem(COOKIE_CONSENT_KEY, consent);
};

const initServicesForConsent = (consent: CookieConsent): void => {
  if (consent === "all") {
    initSentry();
    posthog.opt_in_capturing();
    void import("@/utils/beacon").then(({ initBeacon }) => initBeacon());
  } else {
    posthog.opt_out_capturing();
    closeSentry();
    void import("@/utils/beacon").then(({ destroyBeacon }) => destroyBeacon());
  }
};

export type { CookieConsent };
export { COOKIE_CONSENT_KEY, COOKIE_CONSENT_CHANGED_EVENT, getCookieConsentState, setCookieConsentState, initServicesForConsent };
